import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';
import {FilePdfTwoTone} from '@ant-design/icons';

const {Text, Paragraph} = Typography;
const Content = Layout;

const CincoPD = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Manufacture and Distribution</Paragraph>
        <Text className='BaseText2' style={{marginTop: '0%'}}>The project will cover various topics (e.g. types of detector reagents) that will ensure good management of the manufacturing and distribution of the product:</Text>
        <Text className='BaseText2' style={{marginTop: '2%'}}>
          <ul>
            <li><b>Product Description</b></li>
            <li><b>Aptamers</b></li>
            <li><b>Detection Reagents</b></li>
            <li><b>Manufacturing Equipment</b></li>
            <li><b>Membrane Selection</b></li>
            <li><b>Type of Pad</b></li>
            <li><b>Manufacturing Scheme</b></li>
            <li><b>Storage</b></li>
            <li><b>Packaging</b></li>
            <li><b>Lamination Defects</b></li>
          </ul>
        </Text>
        <Text className='BaseText' style={{marginTop: '3%', textAlign: 'center'}}><i>In the following PDF you can find the entire clinical study.</i></Text>
        <Content style={{width: '100%', marginTop: '1%', background: 'transparent', textAlign: 'right'}}>
          <a style={{width: 'fit-content', marginLeft: 'auto', marginRight: '50px', marginBottom: '5px'}} target='_blank' rel='noopener noreferrer' href='https://static.igem.wiki/teams/4464/wiki/emprendimiento/manufacture-and-distribution.pdf'><FilePdfTwoTone style={{fontSize: '8vh'}} twoToneColor='#eb2f96'/></a>
          <p style={{textAlign: 'right'}}><i>Download Here</i></p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default CincoPD;
